import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 5%) 0px 4px 10px;
  overflow: hidden;
  position: relative;
  height: 100%;

  a & {
    -webkit-transition: 120ms cubic-bezier(0.165, 0.84, 0.44, 1);
    transition: 120ms cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  @media (min-width: 768px) {
    &:hover,
    &:focus {
      box-shadow: 0 16px 32px rgba(0, 0, 0, 0.09);
      transform: translateY(-4px);
      cursor: pointer;
    }
  }

  @media (min-width: 768px) {
    flex-direction: ${({ row }) => (row ? 'row' : 'column')};
  }

  ${({ row }) =>
    row &&
    css`
      @media (max-width: 992px) {
        flex-direction: column;
      }
    `}
`

export const ImageWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  padding-bottom: 60%;
  height: 0px;
  background: rgb(246, 246, 246);
  display: inline-block;
  position: relative;
`

export const Image = styled.img`
  width: 100%;
  left: 0;
  position: absolute;

  @supports (object-fit: cover) {
    top: 0;
    height: 100%;
    object-fit: cover;
  }
`

export const Content = styled.div`
  padding: 24px;
  flex-grow: 1;

  *:last-child {
    margin-bottom: 0;
  }
`

export const CtaContainer = styled.div`
  margin-top: 30px;
`

export const VideoWrapper = styled.div`
  display: block;
  position: relative;
  background: #cccccc;
  padding-bottom: 60%;
`

export const IFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
